import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { banner, Mbanner } from "../../utility/Navigation";

export default function SliderBanner() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // mobile breakpoint
    };
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container-fluid p-0">
      {/* Desktop Slider */}
      {!isMobile && (
        <div className="desktop-slider">
          <Swiper
            spaceBetween={0}
            centeredSlides={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            loop={true}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
          >
            {banner.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="banner-slide">
                  <img
                    src={img}
                    alt={`desktop banner ${index + 1}`}
                    className="w-100 img-fluid h-100 banner-img"
                    style={{ objectFit: "contain" }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      {/* Mobile Slider */}
      {isMobile && (
        <div className="mobile-slider">
          <Swiper
            spaceBetween={0}
            centeredSlides={true}
            autoplay={{ delay: 2000, disableOnInteraction: false }} // different settings if needed
            pagination={{ clickable: true }}
            loop={true}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
          >
            {Mbanner.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="banner-slide">
                  <img
                    src={img}
                    alt={`mobile banner ${index + 1}`}
                    className="w-100 img-fluid h-100 banner-img"
                    style={{ objectFit: "contain" }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
}
